import { useEffect, useState } from "react";
import axios from "axios";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  { id: "fb-0", name: "Add your client", role: "Portland, OR", text: "Replace this with a real client testimonial." },
  { id: "fb-1", name: "Add your client", role: "Beaverton, OR", text: "Add a second quote here." },
  { id: "fb-2", name: "Add your client", role: "Lake Oswego, OR", text: "Third quote goes here." },
];

export default function Testimonials() {
  const [items, setItems] = useState(FALLBACK);
  const [usingReal, setUsingReal] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/testimonials`);
        if (Array.isArray(data) && data.length > 0) {
          setItems(data);
          setUsingReal(true);
        }
      } catch (e) {
        console.warn("Testimonials fallback in use", e);
      }
    })();
  }, []);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-20 lg:py-28 px-6 lg:px-12 bg-[#FDF9F3]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-14 text-center max-w-2xl mx-auto">
          <div className="font-hand text-2xl text-[#A67F4E] mb-2">love notes</div>
          <h2
            data-testid="testimonials-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#3D2E1C]"
          >
            {usingReal ? "Real Portland customers." : "Reviews coming soon."}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.slice(0, 6).map((r, i) => (
            <div
              key={r.id}
              data-testid={`testimonial-${r.id}`}
              className={`relative p-7 bg-white border-2 border-[#E9DFCB] hover:border-[#D6B98D] rounded-2xl transition-all ${i % 2 === 0 ? "-rotate-1" : "rotate-1"} hover:rotate-0`}
            >
              <Quote className="w-7 h-7 text-[#D6B98D] mb-4" strokeWidth={2} />
              <p className="font-serif text-lg leading-snug text-[#3D2E1C] mb-6 italic">
                &ldquo;{r.text}&rdquo;
              </p>
              <div className="border-t border-[#E9DFCB] pt-4">
                <div className="text-sm font-bold text-[#3D2E1C]">{r.name}</div>
                {r.role && <div className="text-xs font-semibold text-[#A67F4E] mt-0.5">{r.role}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
